
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leads",
      function () {
        return require("private-next-pages/leads/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leads"])
      });
    }
  